import { useTranslation } from "react-i18next";
import { Button, Icon, Spinner } from "@atoms";
import { useImageUploader } from "./logic";

const colors = require("@theme/colors") as Record<string, any>;

export type ImageUploaderTemplateProps = {
  openFileSelector: any;
  selectedFiles: any;
  getRootProps: any;
  getInputProps: any;
  logo: any;
}

export const ImageUploaderTemplate = ({
  openFileSelector,
  selectedFiles,
  getRootProps,
  getInputProps,
  logo
}:ImageUploaderTemplateProps): JSX.Element => {
  const { t } = useTranslation();

  const thumbs = selectedFiles.map((file: any) => (
    <div key={file.name} className="w-full h-full relative">
      <img
        src={file.preview}
        className="block object-contain w-full h-full opacity-60"
        // Revoke data uri after image is loaded
        onLoad={() => { URL.revokeObjectURL(file.preview) }}
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner variant="large" />
      </div>
    </div>
  ));

  return (
    <section className="container">
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />

        <div 
          className={`rounded-md w-52 h-52 flex flex-col place-content-center place-self-center ${selectedFiles.length === 0 && !logo ? "bg-white border-2 border-dashed border-gray-300 cursor-pointer hover:border-gray-400 transition-colors" : "#ffffff"}`}
          onClick={selectedFiles.length === 0 && !logo ? openFileSelector : undefined}
        >
          {
          logo && logo !== "" ?
            <div key={"key"} className="w-full h-full bg-white overflow-hidden">
              <img
                src={logo}
                className="block object-contain w-full h-full"
                // Revoke data uri after image is loaded
                // onLoad={() => { URL.revokeObjectURL(file.preview) }}
              />
            </div>
            :
            selectedFiles.length === 0 ?
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                <Icon variant={"upload"} size={32} color="#6B7280" />
              </div>
              <p className="text-sm text-black font-light">{t("imageUploader.uploadLogo")}</p>
            </div>
            : 
            <div className="w-full h-full">
              {thumbs}
            </div>
          }
        </div>
        {(logo && logo !== "") ? (
          <div className="pt-6">
            <Button
              onClick={openFileSelector}
              variant="secondary"
              label={t("imageUploader.updateLogo")}
              stretch
              color="#FFFFFF"
              hoverColor="#FFE8D6"
              textColor={colors.primary.medium}
              borderColor={colors.primary.medium}
              fontWeight={600}
            />
          </div>
        ) : null}
      </div>
    </section>
  );
}
